import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { Button } from '../../Button';
import { Dropdown } from '../../Inputs';
import { useUser } from '../../../shared';
import { useThemeMode } from '../../Theme/ThemeModeContext';
import { useNavigationControls } from '../NavigationContext';
import { navBarHeaderContainer, navBarLeftSideContainer, navBarRightSideContainer, hamburgerButton, themeToggleButton, logoutText, logoutIcon } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var NavBar = function NavBar() {
  var _useNavigationControl = useNavigationControls(),
      allRoutes = _useNavigationControl.allRoutes,
      toggle = _useNavigationControl.toggle,
      isOpen = _useNavigationControl.isOpen;

  var location = useLocation();
  var matchedRoute = allRoutes.find(function (el) {
    return matchPath(location.pathname, el.url);
  });

  var _useUser = useUser(),
      userInfo = _useUser.userInfo,
      logout = _useUser.logout,
      changeCurrentOffice = _useUser.changeCurrentOffice;

  var _useThemeMode = useThemeMode(),
      mode = _useThemeMode.mode,
      toggleTheme = _useThemeMode.toggleTheme;

  return ___EmotionJSX("header", {
    css: navBarHeaderContainer
  }, ___EmotionJSX("div", {
    css: navBarLeftSideContainer
  }, ___EmotionJSX("div", {
    role: "button",
    tabIndex: "0",
    css: hamburgerButton,
    onClick: function onClick() {
      return toggle === null || toggle === void 0 ? void 0 : toggle();
    },
    onKeyDown: function onKeyDown(e) {
      return e.key === 'Enter' && (toggle === null || toggle === void 0 ? void 0 : toggle());
    }
  }, ___EmotionJSX("i", {
    className: isOpen ? 'las la-times' : 'las la-bars'
  })), ___EmotionJSX("h5", null, matchedRoute === null || matchedRoute === void 0 ? void 0 : matchedRoute.label)), ___EmotionJSX("div", {
    css: navBarRightSideContainer
  }, ___EmotionJSX("div", {
    role: "button",
    tabIndex: "0",
    css: themeToggleButton,
    onClick: toggleTheme
  }, ___EmotionJSX("i", {
    className: mode === 'dark' ? 'las la-sun' : 'las la-moon'
  })), ___EmotionJSX(Dropdown, {
    className: "nav-office-dropdown",
    small: true,
    noClear: true,
    placeholder: "\u041E\u0444\u0438\u0441",
    value: userInfo === null || userInfo === void 0 ? void 0 : userInfo.currentOffice,
    displayKey: "name",
    uniqueKey: "id",
    options: userInfo === null || userInfo === void 0 ? void 0 : userInfo.offices,
    onChange: changeCurrentOffice
  }), ___EmotionJSX(Button, {
    small: true,
    type: "secondary",
    onClick: logout
  }, ___EmotionJSX("span", {
    css: logoutText
  }, "\u0418\u0437\u043B\u0435\u0437"), ___EmotionJSX("i", {
    css: logoutIcon,
    className: "las la-sign-out-alt"
  }))));
};

export default NavBar;